<template>
  <div>
    <el-dialog
        :title="'Tạo số điện thoại'"
        :visible.sync="isCreate"
        width="500px"
        :before-close="handleClose"
        top="5vh"
        :close="handleClose"
    >
      <el-form
          :model="formData"
          :rules="rules" ref="formData"
          label-position="left"
          label-width="150px">
        <el-form-item label="Nhập số điện thoại" prop="phone">
          <el-input v-model="formData.phone" maxlength="10"></el-input>
        </el-form-item>
      </el-form>
      <div class="buttons">
        <el-button
            :loading="loading"
            size="small"
            type="success"
            style="margin-right: 10px"
            @click="handleUpload()"
        >
          Tạo mới
        </el-button>
        <el-button size="small" type="danger" @click="handleClose">
          <i class="el-icon-circle-close"/> Đóng
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import manageDataService from "@/services/AdminService/ManageDataService";

export default {
  name: "CreateReceiveMessagesSystemDialog",
  data() {
    return {
      // checkPhone: false,
      formData: {
        phone: "",
      },
      loading: false,
      rules: {
        phone: [
          {required: true, message: 'Không được để trống', trigger: 'change'},
          {min: 10, max: 10, message: 'Số điện thoại phải là 10 chữ số', trigger: 'blur'}
        ],
      }
    }
  },
  props: {
    isCreate: {
      type: Boolean,
      default: false
    },
    listPhone: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    handleClose() {
      this.$refs['formData'].resetFields();
      this.$emit("close");
    },
    handleUpload() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (!this.checkPhone()){
            this.loading = true;
            manageDataService.postReceiveMessagesSystem(this.formData.phone).then((res) => {
              if (res.data.data) {
                this.$message({
                  message: "Tạo số điện thoại thành công",
                  type: "success",
                });
              } else {
                this.$message({
                  message: "Tạo số điện thoại thất bại",
                  type: "error",
                });
              }
              this.loading = false;
              this.handleClose();
            }).catch((err) => {
              this.loading = false;
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
          } else {
            this.$message({
              message: "Số điện thoại đã tồn tại",
              type: "error",
            });
          }
        }
      });
    },
    checkPhone() {
      if (this.$props.listPhone.length > 0) {
        for (let i = 0; i < this.$props.listPhone.length; i++) {
          if (this.formData.phone === this.$props.listPhone[i].phone) {
            return true
          }
        }
      }else return false;
    }
  }

}
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  justify-content: right;
  text-align: right;
  margin-top: 10px;
}
</style>